module.exports = __webpack_public_path__ + "img/Chiclayo.9c0bce39.svg";